const STORAGE_KEY = "siripay_admin_settings";

export const DEFAULT_ADMIN_SETTINGS = {
  giftcard: {
    mode: "dummy",
    apiProvider: "WOOHOO",
    sandboxMode: true,
    autoFulfillment: true,
    logApiRequests: false,
  },
  general: {
    maintenanceMode: false,
    allowNewRegistrations: true,
    defaultCurrency: "INR",
    supportEmail: "support@siripay.com",
    supportPhone: "",
  },
  notifications: {
    emailAlerts: true,
    orderAlerts: true,
    lowStockAlerts: true,
    rewardAlerts: false,
  },
  payments: {
    testMode: false,
    enableUpi: true,
    enableCards: true,
    enableNetBanking: true,
  },
  security: {
    requireOtpForAdmin: true,
    sessionTimeoutMinutes: 60,
  },
};

const deepMerge = (defaults, saved) => ({
  giftcard: { ...defaults.giftcard, ...saved?.giftcard },
  general: { ...defaults.general, ...saved?.general },
  notifications: { ...defaults.notifications, ...saved?.notifications },
  payments: { ...defaults.payments, ...saved?.payments },
  security: { ...defaults.security, ...saved?.security },
});

export const loadAdminSettings = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_ADMIN_SETTINGS };
    return deepMerge(DEFAULT_ADMIN_SETTINGS, JSON.parse(raw));
  } catch {
    return { ...DEFAULT_ADMIN_SETTINGS };
  }
};

export const saveAdminSettings = (settings) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  window.dispatchEvent(new CustomEvent("admin-settings-changed", { detail: settings }));
};

export const updateAdminSettings = (updater) => {
  const current = loadAdminSettings();
  const next = typeof updater === "function" ? updater(current) : deepMerge(current, updater);
  saveAdminSettings(next);
  return next;
};

export const getGiftcardConfig = () => loadAdminSettings().giftcard;
